<script>
  import Button from '@components/buttons/button.svelte'
  import { IconCaretUp, IconCaretDown } from '@tabler/icons-svelte'
  import { cn } from '@lib/utils'
  
  let { label, width = "auto", children, class: className, align = "left", sort, sortKey } = $props()

  let alignClass = $derived(align === "right" ? "text-right" : align === "center" ? "text-center" : "text-left")
  let flexClass = $derived(align === "right" ? "justify-end" : align === "center" ? "justify-center" : "justify-start")
</script>

<th class={cn("py-3 px-4 pr-2 font-medium truncate border-r border-gray-100 last:border-r-0", className, alignClass)} style="width: {width}">
  <div class="flex gap-1 {flexClass}">
    {#if children}
      {@render children?.({ sort, sortKey })}
    {:else if label}
      {label}
    {/if}

    {#if sortKey && sort}
      <Button variant="naked" Icon={sort.direction === "asc" ? IconCaretUp : IconCaretDown} iconSize={12} onclick={() => sort.setSort(sortKey)} />
    {/if}
  </div>
</th>
